import { useQuery } from "@tanstack/solid-query";
import { ChevronDown } from "lucide-solid";
import { type Component, For, Index, Show } from "solid-js";
import { twJoin } from "tailwind-merge";
import { Spinner } from "~/solidJs/shared";
import { ProductsApi } from "~/solidJs/shared/api/ProductsApi";
import { StyledAccordion } from "~/solidJs/shared/ui/molecules/StyledAccordion";
import { SAMPLE_QAS } from "../model";

export const QaSection: Component = () => {
	const qaQuery = useQuery(() => ProductsApi.getQaDataOptions());

	return (
		<div class="flex w-full shrink-0 flex-col items-center gap-10">
			<h3 class="md:header-48-semibold font-semibold text-3xl text-black">
				Questions & Answers
			</h3>
			<div class="flex w-full flex-col px-3 md:px-0">
				<Show
					when={qaQuery.isSuccess && qaQuery.data}
					fallback={
						<Show
							when={qaQuery.isLoading}
							fallback={
								<Show when={qaQuery.isError}>
									<div class="flex w-full flex-col items-start justify-center gap-4 border-border-secondary border-t">
										<For each={SAMPLE_QAS.items}>
											{(group) => (
												<div class="flex w-full items-start justify-start lg:border-border-secondary lg:border-t">
													<div class="w-full pt-5">
														<h3
															class={
																"header-30-semibold w-full text-text-primary"
															}
														>
															{group.heading}
														</h3>
													</div>
													<StyledAccordion.Root
														class="flex w-full flex-col gap-0"
														multiple
													>
														<StyledAccordion.Context>
															{(state) => (
																<Index each={group.questions}>
																	{(item, index) => (
																		<StyledAccordion.Item
																			class="w-full p-0"
																			value={item().id}
																		>
																			<StyledAccordion.ItemTrigger
																				class={twJoin(
																					"w-full justify-between text-left md:text-center",
																					index === 0 &&
																						"border-none"
																				)}
																			>
																				<span class="text-left md:text-center">
																					{
																						item()
																							.question
																					}
																				</span>
																				<ChevronDown
																					size={16}
																					class={twJoin(
																						"",
																						state().getItemState(
																							{
																								value: item()
																									.id
																							}
																						)
																							.expanded &&
																							"rotate-180"
																					)}
																				/>
																			</StyledAccordion.ItemTrigger>
																			<StyledAccordion.ItemContent>
																				{item().answer}
																			</StyledAccordion.ItemContent>
																		</StyledAccordion.Item>
																	)}
																</Index>
															)}
														</StyledAccordion.Context>
													</StyledAccordion.Root>
												</div>
											)}
										</For>
									</div>
								</Show>
							}
						>
							<div class="flex w-full items-center justify-center py-8">
								<Spinner />
							</div>
						</Show>
					}
				>
					{(qaData) => (
						<div class="flex w-full flex-col items-start justify-center gap-14 md:gap-4 lg:border-border-secondary lg:border-t">
							<For each={qaData().items}>
								{(group) => (
									<div class="flex w-full flex-col items-start justify-start gap-4 md:gap-9 lg:flex-row lg:border-border-secondary lg:border-t">
										<div class="w-full pt-5 pl-6 md:pl-0">
											<h3
												class={
													"header-30-semibold w-full text-text-primary"
												}
											>
												{group.heading}
											</h3>
										</div>
										<StyledAccordion.Root
											class="flex w-full flex-col gap-0"
											multiple
										>
											<StyledAccordion.Context>
												{(state) => (
													<Index each={group.questions}>
														{(item, index) => (
															<StyledAccordion.Item
																class="w-full p-0 px-4 md:px-0"
																value={item().id}
															>
																<StyledAccordion.ItemTrigger
																	class={twJoin(
																		"w-full justify-between text-left md:text-center",
																		index === 0 && "border-none"
																	)}
																>
																	{item().question}
																	<ChevronDown
																		size={16}
																		class={twJoin(
																			"",
																			state().getItemState({
																				value: item().id
																			}).expanded &&
																				"rotate-180"
																		)}
																	/>
																</StyledAccordion.ItemTrigger>
																<StyledAccordion.ItemContent>
																	{item().answer}
																</StyledAccordion.ItemContent>
															</StyledAccordion.Item>
														)}
													</Index>
												)}
											</StyledAccordion.Context>
										</StyledAccordion.Root>
									</div>
								)}
							</For>
						</div>
					)}
				</Show>
			</div>
		</div>
	);
};
